import { useQuery } from "@tanstack/react-query";
import { fetchContactInvoices } from "@/api/v1-jwt/invoice/invoice";
import { useAuth } from "@/providers/auth";

export const useContactInvoices = ({
  queryFn,
  queryKey,
  contactId,
  enabled,
  ...rest
} = {}) => {
  const { cognitoId, clientId, userRole } = useAuth();

  const id =
    userRole === "admin" || userRole === "auth_user" ? clientId : cognitoId;

  const isEnabled = !!id && enabled !== false && !!contactId;
  return useQuery({
    queryKey: ["invoices", "contact", contactId],
    queryFn: async () => {
      return await fetchContactInvoices({ userId: id, contactId });
    },
    enabled: isEnabled,
    staleTime: 5 * 60 * 1000,
    ...rest,
  });
};
